import { render } from "./fawDetail.vue?vue&type=template&id=717ff876&scoped=true"
import script from "./fawDetail.vue?vue&type=script&lang=js"
export * from "./fawDetail.vue?vue&type=script&lang=js"

import "./fawDetail.vue?vue&type=style&index=0&id=717ff876&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717ff876"]])

export default __exports__